import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import ShadesContext from './context/shadesContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ShadesContext>
      <App />
    </ShadesContext>
  </React.StrictMode>
);
